import { render, staticRenderFns } from "./MdfeConfiguration.vue?vue&type=template&id=37ce7690&scoped=true"
import script from "./MdfeConfiguration.vue?vue&type=script&lang=js"
export * from "./MdfeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./MdfeConfiguration.vue?vue&type=style&index=0&id=37ce7690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce7690",
  null
  
)

export default component.exports